var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle, _circle2, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConference(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.128,
    height: 688.104,
    viewBox: "0 0 800.128 688.104",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-495.411 -250.992)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(580.986 816.982) rotate(20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,72.523H19.418L28.653,0,0,0Z",
    transform: "translate(6.484 0)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.471,10.725,31.517,0H28.528L8.407,1.027l-4.657.247L.191,38.066,0,40.039H13.35l.429-1.959,1.939-8.9,5.006,8.9,1.1,1.959H57.215c4.383-.024,7.928-3.085,7.947-6.863C66.656,27.163,37.222,14.164,33.471,10.725Z",
    transform: "translate(0 62.152)",
    fill: "#090814"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.129.48,24.637,2.17l-6.5,27.077L-4.584,22.719Z",
    transform: "translate(629.641 478.382)",
    fill: "#ed9da0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(671.581 833.503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.4,634.732h21.04l10.008-72.523-31.052,0Z",
    transform: "translate(-246.844 -562.209)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.681,745.208l-1.954-10.726h-2.989l-20.121,1.027-4.657.247-3.56,36.792-.191,1.972h13.35l.429-1.959,1.939-8.9,5.006,8.9,1.1,1.959h35.394c4.383-.024,7.928-3.085,7.947-6.863C472.866,761.645,443.432,748.646,439.681,745.208Z",
    transform: "translate(-406.21 -672.71)",
    fill: "#090814"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M458.8,362.739a11.967,11.967,0,0,0-9.58,15.5l-20.536,17.775,7.758,15.114,28.648-25.509a11.95,11.95,0,0,0-6.29-22.884Z",
    transform: "translate(287.058 130.678)",
    fill: "#ed9da0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M446.88,408.17l-7.714-15.122-.794-1.554c-8.258,2.9-24.48,12.388-31.877,17.232-2.711-3.778-17.787-20.215-30.822-26.522,0-.011-.011,0-.011,0q-1.344-.647-2.654-1.157a18.334,18.334,0,0,0-6.341-1.316,9.761,9.761,0,0,0-2.847.408,8.005,8.005,0,0,0-2.677,1.373c-2.121,1.634-3.732,4.481-4.64,8.882a17.373,17.373,0,0,0,.805,6.171c3.63,12.036,17.969,25.479,23.04,34.146.5,1.339,5.479,14.52,13.341,19.194a12.684,12.684,0,0,0,1.282.681c.488.068.976.125,1.486.147h.011a20.853,20.853,0,0,0,2.394.034c.408-.011.828-.045,1.248-.079.091-.011.17-.011.261-.023a37.827,37.827,0,0,0,7.7-1.679c.284-.091.567-.182.851-.284a63.377,63.377,0,0,0,6.319-2.541c1.191-.545,2.371-1.134,3.551-1.747,1.429-.749,2.859-1.543,4.254-2.371,1.2-.692,2.382-1.418,3.539-2.167v-.011c.272-.159.545-.34.817-.533h.011c10.346-6.727,18.786-14.543,20.408-17.776a26.268,26.268,0,0,0,2.927-5.8Z",
    transform: "translate(277.355 132.98)",
    fill: "#090814"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M396.035,451.693s28.44,32,21.291,39.148-18.273,9.026-18.273,9.026l-13.6-1.048Z",
    transform: "translate(281.249 127.734)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M364.027,376.021c36.681,21.462,49.016,41.964,32.052,83.221Z",
    transform: "translate(278.368 132.481)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M341.36,535.966c-2.976-1.384-10.368,110.285-10.971,113.091l-42.387,79L348.334,755.1,388,617.356l6.612,50.689L385.8,748.486l39,9.431,26.974-1.927-18.734-229-35.549-64.458Z",
    transform: "translate(268.151 129.192)",
    fill: "#090814"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M364.993,378.81c49.807,34.358,37.645,34.97,38.051,88l23.733,58.766s-83.666,30.023-92.244,10.152S364.993,378.81,364.993,378.81Z",
    transform: "translate(274.239 132.855)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M403.9,458.894c-.1-.363-.227-.783-.363-1.225v-.011c-.216-.715-.465-1.5-.76-2.394-.182-.567-.374-1.18-.59-1.826-.136-.408-.272-.828-.42-1.271-3.993-12.059-12.047-34.543-21.826-59.4v-.011q-1.77-4.475-3.607-9.041c-.113-.272-.216-.556-.329-.828-.488-1.214-.987-2.439-1.486-3.664L360.192,364.9l-7.725-5.037-17.016,15.711s.011.272.034.805c.238,4.844,1.407,31,1.554,61.927.034,7.793.011,15.893-.125,24.027v.216c-.034,2.133,0,3.789.1,5.128a22.338,22.338,0,0,0,.329,2.836c.635,3.494,1.8,4.311,2.428,11.582,0,0-13.386,17.254-5.615,32.024a10.649,10.649,0,0,0,1.861.113c2.745.045,9.143-.125,26.738-.136,3.052-.023,6.432-.023,10.187-.011,24.605,0,11.344-14.237,24.492-27.2.284-.284.567-.556.873-.828a29.791,29.791,0,0,1,2.949-2.348l2.2-6.829.7-2.189.011-.284.068-3.029.147-6.035.1-4.016a14.906,14.906,0,0,0-.59-2.427Z",
    transform: "translate(274.028 130.309)",
    fill: "#090814"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.722,274.171l-3.908,24.39,26.453,10.911Z",
    transform: "translate(432.965 270.036)",
    opacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M380.34,313.365c29.593,16.839,5.3,61.27-24.846,45.449C325.9,341.975,350.2,297.544,380.34,313.365Z",
    transform: "translate(275.417 129.694)",
    fill: "#ed9da0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M326.6,448.837c15.692,18.493,42.433,21.163,62.741,8.753Z",
    transform: "translate(273.339 142.268)",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M397.592,324.19c-2.074,2.7-6.406,1.432-14.889,3.357a35.368,35.368,0,0,0-.989-8.538,24.034,24.034,0,0,1-4.052,9.609c-7.366.817,1.664,23.2-2.108,39.65-4.86-34.712-15.081-25.618-9.917-18.733,3.306,4.408,1.1,17.631-8.815,11.019-16.363,7.777-39.669-30.854-13.839-48.971-.462-9.793,10.435-11.34,17.145-8.329C376.411,291.123,395.015,306.666,397.592,324.19Z",
    transform: "translate(273.989 128.206)",
    fill: "#090814"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.045,2.355C35.788,28.533,12.967-2.46,2.236,23.3c-3.374,9.329,2.415,16,6.076,23.747C9.148,53.413.869,56.642,0,62.5c-.241,13.43,21.426,12.608,27.483,4.135,6.224-8.87-1.208-20.771,2.533-30.291,5.258-13.218,26.641-13.317,28.5-28.695C54.914,2.511,45.213-3.373,40.045,2.355Z",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 564.801, 436.779)",
    fill: "#090814"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M347.267,303.87c-.216.091-.431.182-.624.284h-.011c-.182.091-.363.182-.545.284-.023.011-.034.023-.057.034-.238-.227-.476-.454-.726-.681a2.624,2.624,0,0,0,.045,1.112l.034.136c.227.238.465.465.715.7.227-.17.442-.352.669-.522.136-.113.272-.227.42-.34.023-.295.057-.635.091-1.01Zm6.829-12.615c-5.059-1.157-6.693,5.457-7.181,8.644-1.838-11.571-9.484-7.929-6.84-.034a17.678,17.678,0,0,0,3.891,6.262c.238.272.5.545.771.817-.306,1.588,1.237,1.18,3.324-.284a27.8,27.8,0,0,0,4.254-3.732C356.479,298.561,359.723,292.719,354.1,291.256Zm.159,6.511a39.642,39.642,0,0,1-5.23,5.547q-.9.817-1.838,1.565c-.011.1-.011.193-.023.272a2.082,2.082,0,0,1-.159.318c-.635,1.146-1.35.522-1.622-.431-.023-.034-.057-.068-.079-.1a15.986,15.986,0,0,1-2.348-3.108c-4.685-8.122,2.859-13.647,2.484,1.52a1.438,1.438,0,0,0-.136.442,2.624,2.624,0,0,0,.045,1.112l.034.136c.227.238.465.465.715.7.227-.17.442-.352.669-.522.136-.113.272-.227.42-.34.023-.295.057-.635.091-1.01v-.011c.295-3.04,1.1-8.508,2.586-9.994,3.267-2.507,7.5.2,4.39,3.9Zm-6.988,6.1c-.216.091-.431.182-.624.284h-.011c-.182.091-.363.182-.545.284-.023.011-.034.023-.057.034-.238-.227-.476-.454-.726-.681a2.624,2.624,0,0,0,.045,1.112l.034.136c.227.238.465.465.715.7.227-.17.442-.352.669-.522.136-.113.272-.227.42-.34.023-.295.057-.635.091-1.01Z",
    transform: "translate(275.075 127.156)",
    fill: "#6c63ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M404.686,432.751c8.225-.164,52.405-1.432,59.65-1.12.41-1.435,14.144,16.166,14.478,16.275a2.006,2.006,0,0,1-.671,3.225c-.807.491-72.032-.827-72.895-.655a1.981,1.981,0,0,1-1.768-1.152L403,448.258c-.049-1.824-.647-11.147-.111-12.741a1.973,1.973,0,0,1,1.792-2.767Z",
    transform: "translate(287.048 146.936)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.971,446.61c.418,1,.953,2.267,2.244,2.22l72.143.81a1.99,1.99,0,0,0,1.736-2.921Z",
    transform: "translate(287.081 148.583)",
    opacity: 0.17,
    style: {
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M457.959,401.223c.777-.858,20.064-61.811,21.674-62.321L492.8,328.614l1.177-.565c1.637-.574,5.563-.186,5.209,1.411h0c-3.094,9.473-22.992,63.426-23.428,71.838l-2.4,10.716a1.424,1.424,0,0,1-.9.9,3.074,3.074,0,0,1-1.652.18,4.29,4.29,0,0,1-3.192-1.473C467.441,411.246,457.058,401.442,457.959,401.223Z",
    transform: "translate(293.088 183.869)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M491.847,328.621l-25.186,83.012c.842,1.362,4.784,2.315,5.7.529.016,0,25.838-82.645,25.864-82.695C498.5,327.479,493.356,327.416,491.847,328.621Z",
    transform: "translate(294.045 183.861)",
    opacity: 0.17,
    style: {
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M333.25,200.416,320.459,211.8,306.1,255.353l6.674,3.718Z",
    transform: "translate(451.883 315.462)",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M499.429,433c-.577,4.226,2.162,11.268-17.152,12.442h-.144c-2.53.165-5.167.222-7.784.168-2.146.008-4.284-.059-6.342-.2h-.144c-22.2-1.442-13.837-9.86-14.126-13.884l14.99.134,30.988.268A2.822,2.822,0,0,0,499.429,433Z",
    transform: "translate(248.843 147.746)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M567.744,764.073c-.715,2.521-408.867,2.521-409.638.006C158.82,761.552,566.972,761.552,567.744,764.073Z",
    transform: "translate(337.305 173.131)",
    fill: "#f2f2f2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M509.9,388.455a6,6,0,0,0-6.1,5.888v56.962H386.762a5.892,5.892,0,1,0,0,11.777H503.8v327.6H516V394.344a6,6,0,0,0-6.1-5.888Z",
    transform: "translate(283.532 146.824)",
    fill: "#f2f2f2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M876.451,536.046c-25.36,10.35-54.025,18.238-86.285,23.1a510.936,510.936,0,0,1-63.3,5.369q-27.823.7-58.6-1.254V157.136a7.677,7.677,0,0,1,7.677-7.666l3.062.011,12.281.033h.211l329.677.821h1.5l11.914.033q2.563,8.254,4.77,17.006C1069.045,285.288,1047.125,466.389,876.451,536.046Z",
    transform: "translate(238.564 119.434)",
    fill: "#f2f2f2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M736.6,304.537c.2,13.436-20.91,13.437-20.712,0C715.692,291.1,736.8,291.1,736.6,304.537Z",
    transform: "translate(243.771 135.288)",
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M918.867,318.66H718.973a3.078,3.078,0,1,0,0,6.157H918.867C922.917,324.883,922.817,318.594,918.867,318.66Z",
    transform: "translate(243.772 137.935)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M847.8,329.64H718.974a3.084,3.084,0,0,0,0,6.168H847.8C851.83,335.863,851.763,329.585,847.8,329.64Z",
    transform: "translate(243.771 139.135)",
    fill: "#ccc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M918.868,236.16H718.974a3.084,3.084,0,1,0,0,6.168H918.868C922.917,242.383,922.817,236.1,918.868,236.16Z",
    transform: "translate(243.771 128.913)",
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M847.8,247.15H718.974a3.084,3.084,0,1,0,0,6.168H847.8C851.83,253.373,851.763,247.095,847.8,247.15Z",
    transform: "translate(243.771 130.115)",
    fill: "#6c63ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M847.8,258.66H718.974a3.084,3.084,0,1,0,0,6.168H847.8C851.83,264.883,851.763,258.6,847.8,258.66Z",
    transform: "translate(243.771 131.374)",
    fill: "#6c63ff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M736.6,376.476c.2,13.436-20.91,13.437-20.712,0C715.692,363.04,736.8,363.04,736.6,376.476Z",
    transform: "translate(243.771 143.155)",
    fill: "#6c63ff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M918.868,390.59H718.974a3.084,3.084,0,1,0,0,6.168H918.868C922.917,396.813,922.817,390.535,918.868,390.59Z",
    transform: "translate(243.771 145.8)",
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M847.8,401.58H718.974a3.084,3.084,0,1,0,0,6.168H847.8C851.83,407.8,851.763,401.525,847.8,401.58Z",
    transform: "translate(243.771 147.002)",
    fill: "#ccc"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M733.617,222.11c.195,13.336-20.754,13.336-20.557,0C712.865,208.773,733.813,208.773,733.617,222.11Z",
    transform: "translate(243.461 126.283)",
    fill: "#6c63ff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.474,152.019c-1.591-1.6-348.851,3.069-348.456-1.614C675.309,148.638,1035,144.6,1025.474,152.019Z",
    transform: "translate(239.52 119.241)",
    fill: "#cacaca"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.913,
    cy: 17.913,
    r: 17.913,
    transform: "translate(881.751 250.992)",
    fill: "#cacaca"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.913,
    cy: 17.913,
    r: 17.913,
    transform: "translate(1259.713 250.992)",
    fill: "#cacaca"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M876.451,498.688c-25.36,10.35-54.025,18.238-86.285,23.1a510.936,510.936,0,0,1-63.3,5.369q-28.621-.333-58.6-1.254V511.745C695.172,489.17,810.433,485.565,876.451,498.688Z",
    transform: "translate(238.564 156.791)",
    fill: "#6c63ff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M412.288,444.386a11.966,11.966,0,0,0-18.216.55L367.923,437.6l-8.337,14.8,37.073,9.848a11.95,11.95,0,0,0,15.629-17.86Z",
    transform: "translate(277.771 140.757)",
    fill: "#ed9da0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M361.441,435.487c-1.895-.987-3.789-1.951-5.638-2.847-4.016-1.985-7.748-3.721-10.493-4.9a94.87,94.87,0,0,0,3.2-12.5c3.222-16.245,5.411-41.565-9.279-40.816a19.169,19.169,0,0,0-6.171,1.5c-11.446,6.364-15.371,31.673-20.5,42.12-.9,1.214-9.994,13.828-8.531,23.165,4.152,9.075,17.356,16.835,29.733,21.883l.011.011c2.382.976,4.742,1.849,6.988,2.62,2.564.874,5,1.6,7.192,2.167,4.367,1.134,7.782,1.645,9.427,1.418a26.575,26.575,0,0,0,6.455-.749l2.6-4.583,1.6-2.836,8.361-14.77.862-1.52A124.814,124.814,0,0,0,361.441,435.487Z",
    transform: "translate(270.283 132.265)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConference);
export default __webpack_public_path__ + "static/media/conference.998a8d4497f4fb4639909b32aba6fde8.svg";
export { ForwardRef as ReactComponent };